import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {InputLabel, toggleDescriptionLabel, ToggleGroup} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useFormContext} from "react-hook-form";
import {CustomerType, PosOrderForm} from "@/data/entities/order";
import {emptyNewDeliveryAddress} from "@/data/entities/deliveryAddress";


const AccountTypeSelector = ({isPending}: OrderEditorTabProps) => {
    const intl = useIntl();
    const {register, setValue, getValues, formState: {errors}} = useFormContext<PosOrderForm>();

    // Switching to a guest: forget the selected account and its addresses
    const onCustomerTypeChange = (customerType: CustomerType) => {
        if (customerType !== "GUEST") return;

        setValue("customerId", null);
        setValue("customer", null);
        if (getValues("deliveryAddress.type") === "EXISTING")
            setValue("deliveryAddress", emptyNewDeliveryAddress(), {shouldDirty: true});
    };

    return (
        <ToggleGroup
            containerClassname={"border-b pb-4 border-gray-200 dark:border-slate-700"}
            type={"radio"}
            label={<InputLabel><FormattedMessage id={"customerType"}/></InputLabel>}
            toggles={[
                {
                    value: "GUEST",
                    label: toggleDescriptionLabel(
                        <FormattedMessage id={"withoutAccount"}/>,
                        <FormattedMessage id={"withoutAccountDescription"}/>,
                    ),
                },
                {
                    value: "EXISTING",
                    label: toggleDescriptionLabel(
                        <FormattedMessage id={"existingCustomer"}/>,
                        <FormattedMessage id={"existingCustomerDescription"}/>,
                    ),
                },
            ]}
            groupName={"orderWithExistingUser"}
            togglesProps={{
                ...register("customerType", {
                    onChange: e => onCustomerTypeChange(e.target.value as CustomerType),
                    required: intl.formatMessage({id: "pick-required-option"}),
                }),
            }}
            disabled={isPending}
            error={errors.customerType && errors.customerType.message}
        />
    );
};

export default AccountTypeSelector;